export enum UserDetailsTabEnum {
  BASIC = 'BASIC',
  PERSONAL = 'PERSONAL',
}
